import Vue from 'vue'
import axios from 'axios';


Vue.prototype.$buscarManifesto = async (token) =>{
  try { 
    let res = await axios.post('manifestacaos/buscar',{
      token: token
    });
    return res.data;
  } catch (e) {
    throw e;
  }  
}

Vue.prototype.$assuntos = async () =>{
  try { 
    let res = await axios.get('assuntos/todos',{});
    return res.data;
  } catch (e) {
    throw e;
  }  
}

Vue.prototype.$secretaria = async () =>{
  try { 
    let res = await axios.get('secretaria/todos',{});
    return res.data;
  } catch (e) {
    throw e;
  }  
}


/////////////////\\\\\\\\\\\\\\\\\\\
